import * as VKID from '@vkid/sdk';

const API = import.meta.env.DEV ? '/api' : 'https://api.yumnote.ru';
const REDIRECT = 'https://yumnote.ru/auth/vk/callback';
const LOGIN_STATE = 'yumnote.vk.login.v1';
const random = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), x => x.toString(16).padStart(2, '0')).join('');
export type AccountIdentity = { userId: string; provider: string | null; displayName: string | null; avatarUrl: string | null };
function identity(data: unknown): AccountIdentity {
  if (!data || typeof data !== 'object' || !('userId' in data) || typeof data.userId !== 'string') throw new Error('Не удалось проверить аккаунт.');
  const value = data as Record<string, unknown>;
  const avatarUrl = typeof value.avatarUrl === 'string' && /^https:\/\//i.test(value.avatarUrl) ? value.avatarUrl : null;
  return { userId: data.userId, provider: typeof value.provider === 'string' ? value.provider : data.userId.startsWith('vk:') ? 'vk' : null, displayName: typeof value.displayName === 'string' && value.displayName.trim() ? value.displayName : null, avatarUrl };
}

export async function startVkLogin() {
  const state = random(); const verifier = random();
  sessionStorage.setItem(LOGIN_STATE, JSON.stringify({ state, verifier, createdAt: Date.now() }));
  VKID.Config.init({ app: 54874790, redirectUrl: REDIRECT, state, codeVerifier: verifier, scope: '', mode: VKID.ConfigAuthMode.Redirect });
  await VKID.Auth.login();
}

export async function finishVkLogin(): Promise<AccountIdentity | null> {
  if (location.pathname !== '/auth/vk/callback') return null;
  const params = new URLSearchParams(location.search);
  const code = params.get('code'); const deviceId = params.get('device_id'); const state = params.get('state');
  // Remove the one-time code from history immediately, including on errors.
  history.replaceState(null, '', '/');
  const raw = sessionStorage.getItem(LOGIN_STATE); sessionStorage.removeItem(LOGIN_STATE);
  let pending: { state?: unknown; verifier?: unknown; createdAt?: unknown };
  try { pending = JSON.parse(raw ?? '{}') as typeof pending; } catch { throw new Error('Сеанс входа устарел. Попробуйте снова.'); }
  if (!code || !deviceId || !state || state !== pending.state || typeof pending.verifier !== 'string' || typeof pending.createdAt !== 'number' || Date.now() - pending.createdAt > 10 * 60 * 1000 || pending.createdAt > Date.now()) throw new Error('Сеанс входа устарел. Попробуйте снова.');
  const response = await fetch(`${API}/v1/account/vk`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code, deviceId, state, verifier: pending.verifier }) });
  if (!response.ok) throw new Error('Не удалось войти через VK. Попробуйте снова.');
  return identity(await response.json());
}

export async function currentAccount(): Promise<AccountIdentity | null> {
  let response: Response;
  try { response = await fetch(`${API}/v1/account/session`, { credentials: 'include', cache: 'no-store', signal: AbortSignal.timeout(15000) }); }
  catch { throw new Error('Нет связи с сервером аккаунтов. Проверьте интернет и повторите попытку.'); }
  if (response.status === 401) return null;
  if (!response.ok) throw new Error('Сервер аккаунтов недоступен.');
  return identity(await response.json());
}
export async function logoutAccount(): Promise<void> {
  const response = await fetch(`${API}/v1/account/logout`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: '{}' });
  if (!response.ok && response.status !== 401) throw new Error('Не удалось выйти.');
}
